import Basic from '@/views/backstage/structure/detail_page/common/BasicStructure'
import Rights from '@/views/backstage/structure/detail_page/common/RightsStructure'
import PhysicalObject from '@/views/backstage/structure/detail_page/common/PhysicalObjectStructure'
import ForestryData from '@/views/backstage/structure/detail_page/common/ForestryDataStructure'

let BuildingsFields = {
    'category': {
        display: {
            name: '種類',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'category',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'single-select-as-is',
            options: {
                type: 'fixed',
                list: ['機房','建築物','鐵路軌道'].map(x=>({value:x, label:x})),
                additional: true,
            }
        }
    },
    'era_ad': {
        display: {
            name: '建造年代(西元)',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'era_ad',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'era_none_ad': {
        display: {
            name: '建造年代(非西元)',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'era_none_ad',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'structure_material': {
        display: {
            name: '構造/材料',
            type: 'multi-string',
        },
        source: {
            type: 'db',
            key: 'structure_material',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'multiple-select-as-is',
            options: {
                type: 'fixed',
                list: ['木造','加強磚造','R.C造','金屬','石木造','磚木造'].map(x=>({value:x, label:x})),
                additional: true,
            }
        }
    },
    'area': {
        display: {
            name: '面積',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'area',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'area_unit': {
        display: {
            name: '面積單位',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'area_unit',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'single-select-as-is',
            options: {
                type: 'fixed',
                list: ['平方公尺','公頃'].map(x=>({value:x, label:x})),
                additional: true,
            }
        }
    },
    'ownership': {
        display: {
            name: '所有權屬',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'ownership',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'administrator': {
        display: {
            name: '管理人',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'administrator',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'building_features': {
        display: {
            name: '建物特徵',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'building_features',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'usage_condition': {
        display: {
            name: '使用情形',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'usage_condition',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
}

let Buildings = (front_back) => {

    let fields = [
        BuildingsFields['category'],
        BuildingsFields['era_ad'],
        BuildingsFields['era_none_ad'],
        BuildingsFields['structure_material'],
        BuildingsFields['area'],
        BuildingsFields['area_unit'],
        BuildingsFields['ownership'],
        BuildingsFields['administrator'],
        BuildingsFields['building_features'],
        BuildingsFields['usage'],
    ]
   
    return {
        name: '建築物、土木設施與遺址資料',
        type: 'group',
        fields
    }
}

export default (front_back = 'backstage') => {
    
    let candidates = [].concat(
        Basic('buildings', front_back),
        ForestryData('buildings', front_back),
        Buildings(front_back), 
        Rights('buildings', front_back), 
        PhysicalObject('buildings', front_back))
    
    let fields = candidates.filter( x => x.fields.length > 0)    

    return {
        name: '建築物、土木設施與遺址類',
        type: 'group',
        fields
    }    
}
  

  